module.exports = __webpack_public_path__ + "dfd02f70d9426251dea28f8650713333.svg";